import { Product } from './products'

export interface InventoryCategory {
  slug: string
  name: string
  description: string
}

export const inventoryCategories: InventoryCategory[] = [
  {
    slug: 'bags-backpacks',
    name: 'Bags & Backpacks',
    description: 'Tactical load carriage systems and patrol packs',
  },
  {
    slug: 'clothing',
    name: 'Clothing',
    description: 'Uniforms, combat shirts, and protective wear',
  },
  {
    slug: 'fire-retardants',
    name: 'Fire Retardants',
    description: 'FR textiles, treatments, and protective hoods',
  },
  {
    slug: 'public-order',
    name: 'Public Order',
    description: 'Shields, restraints, and control equipment',
  },
  {
    slug: 'tactical-vests',
    name: 'Tactical Vests',
    description: 'Plate carriers, load bearing, and covert vests',
  },
  {
    slug: 'training-equipment',
    name: 'Training Equipment',
    description: 'Training suits, targets, and protective helmets',
  },
]

export function isRestrictedProduct(product: Product): boolean {
  return (
    product.category === 'public-order' ||
    product.slug.includes('riot') ||
    product.slug.includes('restraint') ||
    product.slug.includes('baton')
  )
}
